module.exports = __webpack_public_path__ + "static/po-australia-logo-82818caa05ad8002c68dc6507b0d6173.png";